@import '~style-sheet-helpers/core.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../../../../constants/spacing.module.less';

.delivery-options-settings {
  height: 100%;
  width: 856px;
}

.loading-indicator-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
}

.loading-indicator {
  height: 100px;
  width: 100px;
}

.explanation-and-key {
  display: flex;
  flex-direction: column;
  font-size: 16px;
  margin-bottom: 10px;

  .title {
    font-size: 24px;
    margin: 20px 0;
  }
}

.action-buttons-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 32px 0 18px;

  > h3 {
    font-size: 20px;
    margin: 0;
    flex: 1;
  }

  .buttons {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex: 1;
    > *:not(:last-child) {
      margin-right: 10px;
    }
  }
}

.delivery-options-list {
  margin-top: 10px;
}

.list-placeholder {
  border: 1px solid @settings-page--stores-selected-checkout-placeholder--border-color;
  border-top: 0;
  padding: 80px 0;
  display: flex;
  flex-direction: column;
  place-items: center center;

  h1 {
    margin: 0 24px 20px;
    text-align: center;
  }

  p {
    font-size: 16px;
    &:not(:last-child) {
      margin-bottom: 30px;
    }
  }
}

.no-options-placeholder {
  border: 1px solid @settings-page--stores-selected-checkout-placeholder--border-color;
  border-top: 0;
  padding: 12px 0;
  display: flex;
  flex-direction: column;
  place-items: center center;
  font-size: 14px;
}

.delivery-option-header {
  line-height: 1.5;
}

.delivery-option-description {
  margin: 0 0 @space-12;
}

.checkout-rates-list {
  list-style: initial;
  padding-left: 20px;
  padding-top: 8px;
  line-height: 1.5;
  width: 100%;

  .item {
    display: list-item;
  }
}

.magento-error-title {
  font-weight: @bold;
  padding-bottom: 12px;
}

.service-setting-checkbox {
  padding-top: 20px;
}

.service-setting-checkbox-note {
  color: @settings-page--stores-selected-checkout-checkbox--text-color;
  font-size: 12px;
}
